"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFieldViewBuilder = void 0;
var core_shared_1 = require("@ikegps/core-shared");
var anchor_field_view_1 = require("./anchor.field.view");
var date_field_view_1 = require("./date.field.view");
var field_view_1 = require("./field.view");
var file_tool_field_view_1 = require("./file.tool.field.view");
var height_field_view_1 = require("./height.field.view");
var image_field_view_1 = require("./image.field.view");
var location_field_view_1 = require("./location.field.view");
var nested_list_field_view_1 = require("./nested.list.field.view");
var number_field_view_1 = require("./number.field.view");
var select_list_field_view_1 = require("./select.list.field.view");
var text_field_view_1 = require("./text.field.view");
var true_size_view_1 = require("./true.size.view");
var vector_collection_field_view_1 = require("./vector.collection.field.view");
var vector_manual_field_view_1 = require("./vector.manual.field.view");
var vector_p2p_field_view_1 = require("./vector.p2p.field.view");
var vertical_separation_field_view_1 = require("./vertical.separation.field.view");
var yesno_field_view_1 = require("./yesno.field.view");
var CollectionFieldViewBuilder = /** @class */ (function () {
    function CollectionFieldViewBuilder() {
    }
    CollectionFieldViewBuilder.getFieldView = function (field) {
        if (core_shared_1.CollectionModelFieldNumber.isNumberField(field)) {
            return number_field_view_1.NumberFieldView;
        }
        if (core_shared_1.CollectionModelFieldText.isTextField(field)) {
            return text_field_view_1.TextFieldView;
        }
        if (core_shared_1.CollectionModelFieldFileTool.isFileToolField(field)) {
            return file_tool_field_view_1.FileToolFieldView;
        }
        if (core_shared_1.CollectionModelFieldLocation.isLocationField(field)) {
            return location_field_view_1.LocationFieldView;
        }
        if (core_shared_1.CollectionModelFieldDate.isDateField(field)) {
            return date_field_view_1.DateFieldView;
        }
        if (core_shared_1.CollectionModelFieldYesNo.isYesNoField(field)) {
            return yesno_field_view_1.YesNoFieldView;
        }
        if (core_shared_1.CollectionModelFieldVector.isVectorField(field)) {
            if (field.provider === core_shared_1.CollectionModelFieldVector.PROVIDER_P2P) {
                return vector_p2p_field_view_1.VectorP2PFieldView;
            }
            if (field.provider === core_shared_1.CollectionModelFieldVector.PROVIDER_COLLECTION) {
                return vector_collection_field_view_1.VectorCollectionFieldView;
            }
            return vector_manual_field_view_1.VectorManualFieldView;
        }
        if (core_shared_1.CollectionModelFieldAnchor.isAnchorField(field)) {
            if (field.tool === core_shared_1.CollectionModelFieldAnchor.COLLLECTION_TOOL_LOCATION) {
                return anchor_field_view_1.AnchorManualFieldView;
            }
            if (field.tool === core_shared_1.CollectionModelFieldAnchor.COLLLECTION_TOOL_VECTOR) {
                if (field.provider === core_shared_1.CollectionModelFieldAnchor.PROVIDER_P2P) {
                    return anchor_field_view_1.AnchorP2PFieldView;
                }
                return anchor_field_view_1.AnchorManualFieldView;
            }
        }
        if (core_shared_1.CollectionModelFieldImage.isImageField(field)) {
            return image_field_view_1.ImageFieldView;
        }
        if (core_shared_1.CollectionModelFieldHeight.isHeightField(field)) {
            return height_field_view_1.HeightFieldView;
        }
        if (core_shared_1.CollectionModelFieldVerticalSeparation.isVerticalSeparationField(field)) {
            return vertical_separation_field_view_1.VerticalSeparationFieldView;
        }
        if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
            return true_size_view_1.TrueSizeView;
        }
        if (core_shared_1.CollectionModelFieldNestedList.isNestedListField(field)) {
            return nested_list_field_view_1.NestedListFieldView;
        }
        if (core_shared_1.CollectionModelFieldSelectList.isSelectListField(field)) {
            return select_list_field_view_1.SelectListFieldView;
        }
        return field_view_1.SimpleFieldView;
    };
    return CollectionFieldViewBuilder;
}());
exports.CollectionFieldViewBuilder = CollectionFieldViewBuilder;
//# sourceMappingURL=field.view.builder.js.map